import { render, staticRenderFns } from "./TableCardButton.vue?vue&type=template&id=2bf22cfa&lang=pug&"
import script from "./TableCardButton.vue?vue&type=script&lang=js&"
export * from "./TableCardButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports